import { flatten, identity } from 'lodash';

import asArray from 'utils/arrays/asArray.util';
import fromEntriesToObject from 'utils/converters/object/fromEntriesToObject.util';
import asObject from 'utils/objects/asObject.util';

const asFilteredArray = (value) => asArray(value).filter(identity);

const fromRoleExecutionToInfo = (roleExecution) => {
  const rx = asObject(roleExecution);
  const {
    id,
    name,
    description,
    duration,
    processing,
    price,
    variable_pricing: variablePricing,
    service_id: serviceId,
    role_id: roleId,
  } = rx;

  const { id: categoryId, name: categoryName, color: categoryColor } = asObject(rx.category);

  return {
    roleExecutionId: id,
    serviceId,
    roleId,
    categoryId,
    name,
    description,
    duration,
    processing,
    variablePricing,
    price,
    categoryName,
    categoryColor,
  };
};

const fromCategoryToInfo = ({ id, name, color, services }) => ({
  categoryId: id,
  name,
  color,
  serviceIds: asArray(services)
    .filter(identity)
    .map(({ id, service_id: sid }) => id || sid),
});

const fromServiceToInfo = (service) => {
  const {
    name,
    duration,
    processing,
    variable_pricing: variablePricing,
    price,
    category: categoryId,
    patch_test: patchTest,
  } = service ?? {};

  const roleExecutions = asFilteredArray(service?.role_executions).map(fromRoleExecutionToInfo);
  const serviceId = service?.id || service?.service_id;

  return { serviceId, categoryId, name, duration, processing, variablePricing, price, patchTest, roleExecutions };
};

const reduceGetServices = (state, action) => {
  const response = asFilteredArray(action?.response);

  const categoryList = response.map(fromCategoryToInfo);

  const serviceList = flatten(
    response.map((category) =>
      asFilteredArray(category.services)
        .filter(identity)
        .map(fromServiceToInfo)
        .map((service) => {
          const { id: categoryId, name: categoryName, color: categoryColor } = asObject(category);
          return { ...service, categoryId: service.categoryId || categoryId, categoryName, categoryColor };
        }),
    ),
  );

  const categoryMap = fromEntriesToObject(categoryList.map((c) => [c.categoryId, c]));
  const serviceMap = fromEntriesToObject(serviceList.map((s) => [s.serviceId, s]));

  return { ...state, categoryList, categoryMap, serviceList, serviceMap };
};

export default reduceGetServices;
